module.exports = __webpack_public_path__ + "static/media/default-cover.75b55210.png";